import axios from 'axios';
import interceptorRequestAxios from '../interceptors/request-axios';
import { interceptorResponseAxios, interceptorResponseErrorAxios } from '../interceptors/response-axios';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_4);
const CLIENT = process.env.REACT_APP_CLIENT_ID_PASS;
const token = retornoHashValor(process.env.REACT_APP_12);
const apiPagamento = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
    }
});

if (process.env.REACT_APP_ENV === 'prod') {
    apiPagamento.interceptors.request.use(interceptorRequestAxios);
    apiPagamento.interceptors.response.use(interceptorResponseAxios, interceptorResponseErrorAxios);
}

apiPagamento.interceptors.request.use(
    async config => {
        try{
            const timeOutExpire = localStorage.getItem('timeOutExpire');

            if (timeOutExpire) {
                const now = new Date();
                const past = new Date(timeOutExpire);
                const diff = Math.abs(now.getTime() - past.getTime());
                const days = Math.ceil(diff / (1000 * 60 * 60));
                const min = Math.ceil(diff / (1000 * 60));

                if (days > 1) {
                    localStorage.setItem('timeOutExpire', new Date());
                } else if (min > 50) {
                    localStorage.setItem('timeOutExpire', new Date());
                }
            } else {
                localStorage.setItem('timeOutExpire', new Date());
            }

            const client_id = CLIENT;
            const access_token = localStorage.getItem('access_token');

            config.headers['client_id'] = client_id;
            config.headers['access_token'] = access_token;

            return config;
        }catch( error){
            console.log(error);
        }
    });

export default apiPagamento;
